import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { SnackbarKey, useSnackbar } from 'notistack';
import { SnackbarNotificationState } from '../types/snackbar';
import { removeSnackbar } from '../store/snackbar';
import useAppSelector from '../../gatsby-plugin-redux/hooks/useAppSelector';

let displayed: (SnackbarKey | undefined)[] = [];

const useNotifier = () => {
  const dispatch = useDispatch();
  const notifications = useAppSelector<SnackbarNotificationState[]>(
    (store) => store.snackbar.notifications,
  );
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (id?: SnackbarKey) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id: SnackbarKey) => {
    displayed = [...displayed.filter((key) => id !== key)];
  };

  useEffect(() => {
    notifications.forEach(({
      key, message, isDismissed = false, ...options
    }) => {
      if (isDismissed) {
        // dismiss snackbar using notistack
        closeSnackbar(key);
        return;
      }

      // do nothing if snackbar is already displayed
      if (displayed.includes(key)) return;

      // display snackbar using notistack
      enqueueSnackbar(message, {
        key,
        ...options,
        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey);
          }
        },
        onExited: (event, myKey) => {
          // remove this snackbar from redux store
          dispatch(removeSnackbar(myKey));
          removeDisplayed(myKey);
        },
      });

      // keep track of snackbars that we've displayed
      storeDisplayed(key);
    });
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch]);
};

export default useNotifier;
